import { CSSObject } from "@styled-system/css";

export interface CSSProps {
  css?: CSSObject;
}

export const css = ({ css }: CSSProps) => css;
